export default __webpack_public_path__ + "static/media/prelateatarms.0eb46f53.png";